import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';

import DataTableList from '../../components/DataTable/DataTableList'
import SingleSuspendPopup from '../../components/SingleSuspendPopup';
import AddNewFounder from '../../components/Founders/AddNewFounder';
import MultipleSuspendPopup from '../../components/MultipleSuspendPopup';
import NoResults from '../../components/Noresults';
import CustomDatePicker from '../../components/CustomDatePicker';
import Dropdown from '../../components/Dropdown/Dropdown';

import { DateInRange } from '../../utils/dateRange';
import { useStaticDataStore } from '../../stores/staticData';
import { USER_MEMBER } from '../../constants/common';
import { dateFormat, formattedDate } from '../../utils/formattedDate';
import { founderListApi } from '../../api/usersApi';

import search from '../../assets/images/search.svg';
import avatar from '../../assets/images/Avatar.png'

const SuspendedFounders = (props) => {
  const {
    setShowAddNewFounderPopup,
    setSelectFounder,
    isLoading,
    isLoadingData,
    founderList,
    totalPage,
    setEditFounder,
    setIsLoadingData,
    currentPage,
    setSearchQuery,
    searchQuery,
    setFilterFounder,
    filterFounder,
    setShowSuspendPopup,
    setMultipleSuspendPopup,
    selectedRows,
    setSelectedRows,
    isAllSelected,
    setIsAllSelected,
    toggleSelect,
    setErrorMessage,
    setCurrentPage,
    setReason,
    LazyImage } = props

  const { data: staticData } = useStaticDataStore();
  const userUniversityRef = useRef();
  const userIndustryRef = useRef();
  const userStartupStagesRef = useRef();
  const userFounderRef = useRef();
  const userInvestmentRef = useRef();
  const userDateRef = useRef();
  const userSuspendedDateRef = useRef();

  let university = [];
  if (staticData?.university?.length) {
    university = staticData?.university;
  }

  let industryTags = [];
  if (staticData?.industryTags?.length) {
    industryTags = staticData?.industryTags;
  }

  let startupStages = [];
  if (staticData?.startupStages?.length) {
    startupStages = staticData?.startupStages;
  }

  let investmentTerm = [];
  if (staticData?.investmentTerm?.length) {
    investmentTerm = staticData?.investmentTerm;
  }

  const userMember = USER_MEMBER;

  const [userUniversitySelect, setUserUniversitySelect] = useState(false)
  const [userIndustrySelect, setUserIndustrySelect] = useState(false)
  const [userStartupStagesSelect, setUserStartupStagesSelect] = useState(false)
  const [userFoundersSelect, setUserFoundersSelect] = useState(false)
  const [userInvestmentSelect, setUserInvestmentSelect] = useState(false)
  const [userRegistedDateSelect, setUserRegistedDateSelect] = useState(false)
  const [userSuspendedDateSelect, setSuspendedDateSelect] = useState(false)
  const [columnWidths, setColumnWidths] = useState([]);

  useEffect(() => {
    if (founderList?.length > 0) {
      calculateColumnWidths().then(() => {
        setTimeout(() => {
          setIsLoadingData(false);
        }, 1000);
      });
    }
  }, [founderList]);


  const handleMasterCheckboxChange = () => {
    if (isAllSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(founderList?.map((row) => row?.userId));
    }
    setIsAllSelected(!isAllSelected);
  };

  const handleDelete = async () => {
    if (selectedRows?.length === 1) {
      const selected = founderList?.find((row) => row?.userId === selectedRows[0]);
      if (selected) {
        setSelectFounder(selected);
      }
      setShowSuspendPopup(true);
    }
    if (selectedRows?.length > 1) {
      setMultipleSuspendPopup(true);
    }
    setErrorMessage('')
  };

  const handleEditClick = async (row) => {
    try {
      setEditFounder(true);
      setSelectFounder(row);
    } catch (error) {
      console.error('Failed to fetch user detail on edit:', error);
    }
  };

  const calculateColumnWidths = () => {
    return new Promise((resolve) => {
      const tempWidths = founderList?.reduce((acc, row) => {
        Object?.keys(row)?.forEach((key) => {
          const dataValue = row[key]?.toString();
          const title = row[key];

          let maxContentLength = 0;

          if (key === 'industryTags' || key === 'startupStages' || key === 'university') {
            const categories = row[key];

            if (categories?.length > 1) {
              let tempCatLength = 0;

              for (let i = 0; i < 1; i++) {
                tempCatLength = tempCatLength + categories[i]?.length;
              }

              maxContentLength = Math?.max(tempCatLength, title?.length);

            } else {
              if (categories?.length == 0) {
                maxContentLength = Math?.max(dataValue?.length + 5);
              } else {
                maxContentLength = Math?.max(dataValue?.length + 3, title?.length);
              }
            }

          } else {
            maxContentLength = Math?.max(dataValue?.length, title?.length);
          }

          if (!acc[key] || maxContentLength > acc[key]) {
            acc[key] = maxContentLength;
          }
        });
        return acc;
      }, {});
      if (tempWidths !== undefined) {
        const widthMap = Object?.keys(tempWidths)?.reduce((acc, key) => {

          if (key === 'industryTags' || key === 'startupStages' || key === 'university') {
            founderList.forEach((row) => {
              const categoryWidth = tempWidths[key] * 10 + 40;
              acc[key] = `${categoryWidth}px`;
            });
          } else {
            acc[key] = `${tempWidths[key] * 10 + 40}px`;
          }
          return acc;
        }, {});

        setColumnWidths(widthMap);
      }
      resolve();
    });

  };
  const customStyles = {
    headCells: {
      style: {
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '24px',
        color: '#666666'
      },
    },
  };

  const columns = [
    {
      name: 'Founder name',
      selector: (row) => row?.name,
      cell: (row) => {
        return <div className="founder-content founderTable" onClick={() => { handleEditClick(row); setReason(''); }}>
          <LazyImage
            src={row?.profileImg || avatar}
            alt="Suspended founder"
          />
          <div className="founder-brief">
            <span className="founder-name">
              {row?.name || 'NO NAME'}
            </span>
          </div>
        </div>
      },
      sortable: true,
      minWidth: columnWidths['name'] && `${parseInt(columnWidths['name']) + 50}px`,
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 500, lineHeight: '20px', letterSpacing: '-0.28px' },
    },
    {
      name: 'Email address',
      selector: (row) => row?.email,
      cell: (row) => {
        return <p className="user-mail">{row?.email}</p>
      },
      sortable: true,
      minWidth: columnWidths['email'] && (parseInt(columnWidths['email']) > 300) ? '300px' : `${parseInt(columnWidths['email']) - 10}px`,
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
    },
    {
      name: 'Option',
      selector: (row) => row?.university,
      cell: (row) => {
        const optionKeys = row.university?.map(opt => opt?.trim()) || [];
        const matchedLabels = optionKeys?.map(itemkey => {
          const match = university?.find(opt => opt?.key === itemkey);
          return match ? match.value : itemkey;
        });
        return <p className="user-mail">{matchedLabels?.join(', ')}</p>;
      },
      sortable: false,
      width: columnWidths['university'] && `${parseInt(columnWidths['university']) + 150}px`,
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
    },
    {
      name: 'Startup name',
      selector: (row) => row?.companyName,
      cell: (row) => {
        return <p className="user-mail">{row?.companyName}</p>
      },
      sortable: true,
      width: columnWidths['companyName'] && `${parseInt(columnWidths['companyName']) + 20}px`,
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
    },
    {
      name: 'Industry',
      selector: (row) => row?.industryTags || staticData?.industryTags?.map(item => item?.key),
      sortable: false,
      cell: (row) => {
        const industryTags = row?.industryTags?.length
          ? row?.industryTags
          : staticData?.industryTags?.map(item => item?.key) || [];

        const industry = industryTags?.slice(0, 1);
        const industryFull = industryTags?.slice(1);

        const getIndustryValue = (key) => {
          const found = staticData?.industryTags?.find(item => item?.key === key);
          return found ? found?.value : key;
        };
        return (
          <div className="industriesCategory">
            <div>
              {industry?.map((key, index) => (
                <span key={index}>{getIndustryValue(key)}</span>
              ))}
              {industryTags?.length > 1 && (
                <div className="industriesList">
                  <span>+{industryTags?.length - 1}</span>
                  <div className="industriesTooltip ">
                    {industryFull?.map((key, idx) => (
                      <p key={idx}>{getIndustryValue(key)}</p>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      },
      paddingLeft: 0,
      width: columnWidths['industryTags'] && `${parseInt(columnWidths['industryTags']) + 35}px`,
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", width: columnWidths['industryTags'] && `${parseInt(columnWidths['industryTags']) - 10}px`, lineHeight: '20px' },
    },
    {
      name: 'Startup stage',
      selector: (row) => row?.startupStages || staticData?.startupStages?.map(item => item?.key),
      sortable: false,
      cell: (row) => {
        const startupStages = row?.startupStages?.length
          ? row?.startupStages
          : staticData?.startupStages?.map(item => item?.key) || [];

        const startupStage = startupStages?.slice(0, 1);
        const startupStageFull = startupStages?.slice(1);

        const getStartupStageValue = (key) => {
          const found = staticData?.startupStages?.find(item => item?.key === key);
          return found ? found?.value : key;
        };
        return (
          <div className="industriesCategory">
            <div>
              {startupStage?.map((item, index) => (
                <span key={index}>{getStartupStageValue(item)}</span>
              ))}

              {startupStages?.length > 1 && (
                <div className="industriesList">
                  <span>+{startupStages?.length - 1}</span>
                  <div className="industriesTooltip">
                    {startupStageFull?.map((item, idx) => (
                      <p key={idx}>{getStartupStageValue(item)}</p>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      },
      paddingLeft: 0,
      width: columnWidths['startupStages'] && `${parseInt(columnWidths['startupStages']) + 25}px`,
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", width: columnWidths['startupStages'] && `${parseInt(columnWidths['startupStages']) + 40}px`, fontSize: "12px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.24px' },
    },
    {
      name: 'Founders',
      selector: (row) => row?.teamCount,
      cell: (row) => {
        return <p className="user-founders">{row?.teamCount}</p>
      },
      sortable: true,
      width: columnWidths['teamCount'] && `${parseInt(columnWidths['teamCount']) + 50}px`,
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
    },
    {
      name: 'Investment term',
      selector: (row) => row?.investmentTerm,
      cell: (row) => {
        const term = investmentTerm?.find(item => item?.key === row?.investmentTerm)?.value || row?.investmentTerm;
        return <p className="user-founders">{term}</p>;
      },
      sortable: true,
      width: founderList?.some(row => row?.investmentTerm === 'GRANTS')
        ? '280px'
        : columnWidths['investmentTerm'] && `${parseInt(columnWidths['investmentTerm']) + 90}px`,
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
    },
    {
      name: 'Date registered',
      selector: (row) => row?.registeredAt,
      cell: (row) => {
        return <p className="user-founders">{formattedDate(row?.registeredAt)}</p>
      },
      sortable: true,
      width: columnWidths['registeredAt'] && `${parseInt(columnWidths['registeredAt']) - 110}px`,
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
    },
    {
      name: 'Suspended Date',
      selector: (row) => row?.suspendedAt,
      cell: (row) => {
        return <p className="user-founders">{formattedDate(row?.suspendedAt || row?.registeredAt)}</p>
      },
      sortable: true,
      width: columnWidths['suspendedAt'] && `${parseInt(columnWidths['suspendedAt']) - 140}px`,
      minWidth: '135px',
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
    },
    {
      name: 'Actions',
      cell: (row) => {
        return (
          <>
            <div className='table-actions'>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => { setShowSuspendPopup(true); setSelectFounder(row); setErrorMessage(''); }}>
                <path d="M1.5 7.5C1.5 7.5 3.00374 5.45116 4.22538 4.22868C5.44702 3.0062 7.1352 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.92268 15.75 3.32633 13.6907 2.51382 10.875M1.5 7.5V3M1.5 7.5H6" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </>
        )
      },
      justifyContent: 'flex-end',
      allowOverflow: true,
      button: true,
      minWidth: "55px",
      paddingRight: '16px',
      width: '70px',
      style: { textAlign: 'right', width: '70px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px" },
    },
  ]

  return (
    <div className='active-founders'>
      <div className='active-founder-top'>
        <div className='pagesSearch twoItemWrap'>
          <div className="pageSearchInput">
            <input type="text" name="pages_search" className="inputFields" id="pages_search" placeholder={'Search suspended founders...'} autoComplete="off" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
            <img src={search} alt="Search" />
          </div>

          <Dropdown
            ref={userUniversityRef}
            selectedDropdown={userUniversitySelect}
            setSelectedDropdown={setUserUniversitySelect}
            items={university}
            setSelectedValue={(newValue) =>
              setFilterFounder((prev) => ({
                ...prev,
                university: newValue
              }))
            }
            selectedValue={filterFounder?.university ?? []}
            name={'University'}
          />

          <Dropdown
            ref={userIndustryRef}
            selectedDropdown={userIndustrySelect}
            setSelectedDropdown={setUserIndustrySelect}
            items={industryTags}
            setSelectedValue={(newValue) =>
              setFilterFounder((prev) => ({
                ...prev,
                industry: newValue
              }))
            }
            selectedValue={filterFounder?.industry ?? []}
            name={'Industry'}
          />

          <Dropdown
            ref={userStartupStagesRef}
            selectedDropdown={userStartupStagesSelect}
            setSelectedDropdown={setUserStartupStagesSelect}
            items={startupStages}
            setSelectedValue={(newValue) =>
              setFilterFounder((prev) => ({
                ...prev,
                startupStage: newValue
              }))
            }
            selectedValue={filterFounder?.startupStage ?? []}
            name={'Startup stage'}
          />

          <Dropdown
            ref={userFounderRef}
            selectedDropdown={userFoundersSelect}
            setSelectedDropdown={setUserFoundersSelect}
            items={userMember}
            setSelectedValue={(newValue) =>
              setFilterFounder((prev) => ({
                ...prev,
                teamCount: newValue
              }))
            }
            selectedValue={filterFounder?.teamCount ?? []}
            name={'Founders'}
          />

          <Dropdown
            ref={userInvestmentRef}
            selectedDropdown={userInvestmentSelect}
            setSelectedDropdown={setUserInvestmentSelect}
            items={investmentTerm}
            setSelectedValue={(newValue) =>
              setFilterFounder((prev) => ({
                ...prev,
                investmentTerm: newValue
              }))
            }
            selectedValue={filterFounder?.investmentTerm ?? []}
            name={"Investment Terms"}
          />

          <CustomDatePicker
            onApply={(dateRange) => {
              setFilterFounder(prev => ({
                ...prev,
                registedDate: dateRange
              }));
              setUserRegistedDateSelect(false);
            }}
            selectedDate={filterFounder?.registedDate}
            onCancel={() => setUserRegistedDateSelect(false)}
            isSelectDate={userRegistedDateSelect}
            ref={userDateRef}
            setSelectDate={setUserRegistedDateSelect}
            label={"Date registered"}
          />

          <CustomDatePicker
            onApply={(dateRange) => {
              setFilterFounder(prev => ({
                ...prev,
                suspendedDate: dateRange
              }));
              setSuspendedDateSelect(false);
            }}
            selectedDate={filterFounder?.suspendedDate}
            onCancel={() => setSuspendedDateSelect(false)}
            isSelectDate={userSuspendedDateSelect}
            ref={userSuspendedDateRef}
            setSelectDate={setSuspendedDateSelect}
            label={"Date suspended"}
          />

        </div>
        <div className='new-founder'>
          {selectedRows?.length > 0 &&
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => { handleDelete(); setReason(''); }}>
              <path d="M1.5 7.5C1.5 7.5 3.00374 5.45116 4.22538 4.22868C5.44702 3.0062 7.1352 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.92268 15.75 3.32633 13.6907 2.51382 10.875M1.5 7.5V3M1.5 7.5H6" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          }
          <button className='new-founder-button' onClick={() => {
            setShowAddNewFounderPopup(true);
            setErrorMessage('');
          }}>New Founder</button>
        </div>
      </div>
      <div className='table-pagination-wrapper founder-list'>
        <div className={`pagesTable dataTable-list ${(isLoadingData) ? 'loading-list' : ''}`}>
          <DataTableList
            data={founderList}
            columns={columns}
            customStyles={customStyles}
            onChangePage={setCurrentPage}
            paginationTotalRows={totalPage}
            currentPage={currentPage}
            selectableRowsComponent="input"
            selectableRows={true}
            selectAllRows={isAllSelected}
            onSelectAllChange={handleMasterCheckboxChange}
            clearSelectedRows={toggleSelect}
            onSelectedRowsChange={({ selectedRows }) => {
              const selectedIds = selectedRows?.map((row) => row?.userId);
              setSelectedRows(selectedIds);
              setIsAllSelected(selectedIds?.length === founderList?.length);
            }}
            progressPending={isLoading}
            progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
            noDataComponent={<NoResults title='No suspended founders' description="Looks like no founders have been suspended - that's a good sign! Everyone’s playing nice for now, but if anything changes, you’ll see it here." />}
          />
        </div>
      </div>
    </div>
  )
}

export default SuspendedFounders